module.exports = __webpack_public_path__ + "img/途牛_01.73f2afb9.jpg";